import { useState, useContext } from "react";
import ISlotService from "../services/ISlotService";
import { container } from "tsyringe";
import { FatalErrorContext } from "../contexts/FatalErrorContext";
import IPractitioner from "../components/calendar/IPractitioner";

const usePractitioners = () => {
  const { fatalErrorSet } = useContext(FatalErrorContext);

  const slotService = container.resolve<ISlotService>("ISlotService");

  let [practitioners, setPractitioners] = useState<{practitioners: IPractitioner[]}>();

  const getPractitioners = async () => {
    await slotService
      .getPractitioners()
      .then((practitioners) => {
        return setPractitioners({practitioners: practitioners.practitioners});
      }
      )
      .catch((error) => {
          fatalErrorSet({
            statusCode: error?.response?.status || 500,
            message: error?.response.data?.message || "",
          });
        }
      );
      
  };

  return { practitioners, getPractitioners };
};

export default usePractitioners;
